import Cookies from "universal-cookie";

const cookies = new Cookies();

/**
 * Persists login data from OAuth callback query parameters (Option B).
 * Keys match ai_backend FrontendAuthRedirectBuilder.
 */
export function saveAuthFromQueryParams(searchParams) {
    const token = searchParams.get("token");
    if (!token) {
        throw new Error("token_missing");
    }

    const role = searchParams.get("role") ?? "";

    cookies.set("token", token, { path: "/" });
    cookies.set("name", searchParams.get("name") ?? "", { path: "/" });
    cookies.set("role", role, { path: "/" });
    cookies.set("userConnectId", searchParams.get("userConnectId") ?? "", { path: "/" });
    cookies.set("gozinesh", searchParams.get("gozinesh") ?? "", { path: "/" });
    cookies.set("face", searchParams.get("face") ?? "", { path: "/" });
    cookies.set("wordCloud", searchParams.get("wordCloud") ?? "", { path: "/" });
    cookies.set("createImage", searchParams.get("createImage") ?? "", { path: "/" });
    cookies.set("supervisor", searchParams.get("supervisor") ?? "", { path: "/" });
    cookies.set("chatbot", searchParams.get("chatbot") ?? "", { path: "/" });

    return { role };
}

export function clearAuthCookies() {
    const keys = [
        "token",
        "name",
        "role",
        "userConnectId",
        "gozinesh",
        "face",
        "wordCloud",
        "createImage",
        "supervisor",
        "chatbot",
    ];
    keys.forEach((key) => cookies.remove(key, { path: "/" }));
}

/** Where to go after a successful login. */
export function getPostLoginPath(role) {
    if (role === "Admin") {
        return "/mainAdmin/users";
    }
    return "/mainAdmin/home";
}

const ERROR_MESSAGES_FA = {
    token_missing: "توکن ورود دریافت نشد. لطفاً دوباره وارد شوید.",
    missing_id_token: "پاسخ سرویس احراز هویت ناقص بود. لطفاً دوباره تلاش کنید.",
    local_session_failed: "ایجاد نشست در سامانه ناموفق بود. با پشتیبانی تماس بگیرید.",
    callback_failed: "خطا در تکمیل ورود. لطفاً دوباره تلاش کنید.",
    access_denied:
        "شما مجوز دسترسی به سامانه را ندارید. لطفاً با پشتیبانی تماس حاصل نمایید.",
};

export function getOAuthErrorMessage(errorCode, errorDescription) {
    if (errorDescription) {
        return errorDescription;
    }
    return ERROR_MESSAGES_FA[errorCode] ?? "ورود ناموفق بود. لطفاً دوباره تلاش کنید.";
}
